module.exports = __webpack_public_path__ + "img/instructions_playlists.39554a86.png";